import '../vue/store/global'
import Vue from 'vue'

// Config
Vue.config.devtools = true
Vue.config.productionTip = false
Vue.config.silent = true

// Cart
window.PSVueCartProfiles = new Vue({
  name: 'CartProfilesWrapper',
  components: {
    cart_profiles: require('../vue/components/CartProfiles.vue').default,
  },
}).$mount('.cart-profiles')

// Account
window.PSVueAccountProfiles = new Vue({
  name: 'AccountProfilesWrapper',
  components: {
    account_profiles: require('../vue/components/AccountProfiles.vue').default,
  },
}).$mount('.account-profiles')
